export enum FeatureLabelKey {
  RECOMMENDED = 'recommended',
  FASTEST = 'fastest',
  CHEAPEST = 'cheapest',
}

/**
 * How many best-ranked offers (by backend ranking `rank`) get the
 * "Подобрано для вас" personalization label on the search results page.
 * Only applied inside the ranking experiment (variant B).
 */
export const TOP_RANKED_OFFERS_COUNT = 6;
